import { Stack, Tooltip, Typography } from "@mui/material";

import type { SupportedMedium } from "./types";
import type { Frame } from "@/types/dragon-tiles";

interface MediumRevenueMetricProps {
  frame: Frame;
  selectedMedium: SupportedMedium | null;
}

function formatRpm(rpm: number, currencyCode: string): string {
  if (!isFinite(rpm)) return "N/A";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currencyCode || "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(rpm);
}

export function MediumRevenueMetric({
  frame,
  selectedMedium,
}: MediumRevenueMetricProps) {
  // RPM is open/click (email) attribution, so it only applies to the email
  // medium. The value rides on the frame payload (frame.metrics) — no fetch.
  if (selectedMedium !== "email" || !frame.metrics) return null;

  return (
    <Stack
      direction="row"
      spacing={2}
      alignItems="center"
      sx={{ backgroundColor: "warning.light", alignSelf: "start" }}
    >
      <Tooltip title="Revenue per 1,000 sends (5-day open/click attribution)">
        <Typography variant="subtitle3">
          <span>RPM: </span>
          <span>
            {formatRpm(frame.metrics.rpm, frame.metrics.currencyCode)}
          </span>
        </Typography>
      </Tooltip>
    </Stack>
  );
}
